(function () {
  var SELECTOR = "video[data-viewport-media]";

  function activate(video) {
    if (video.dataset.viewportVideoStarted) return;
    video.dataset.viewportVideoStarted = "true";

    var sources = video.querySelectorAll("source[data-src]");
    if (!sources.length) return;

    video.preload = "auto";
    for (var i = 0; i < sources.length; i++) {
      sources[i].src = sources[i].getAttribute("data-src");
      sources[i].removeAttribute("data-src");
    }
    video.load();

    if (video.autoplay) {
      video.muted = true;
      video.playsInline = true;
      var played = video.play();
      if (played && played.catch) played.catch(function () {});
    }
  }

  var watched = [];

  function evaluate() {
    for (var i = 0; i < watched.length; i++) {
      if (watched[i].query.matches) activate(watched[i].video);
    }
  }

  function start() {
    var videos = document.querySelectorAll(SELECTOR);

    for (var i = 0; i < videos.length; i++) {
      var video = videos[i];
      var media = video.getAttribute("data-viewport-media");
      if (!media) continue;
      watched.push({ video: video, query: window.matchMedia(media) });
    }

    if (!watched.length) return;

    evaluate();

    for (var j = 0; j < watched.length; j++) {
      var query = watched[j].query;
      if (query.addEventListener) {
        query.addEventListener("change", evaluate);
      } else if (query.addListener) {
        query.addListener(evaluate);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
